<template>
<body class="background bg-gray-100">
<div class="bg-gray-100 min-h-full">
  <div class="">
    <div class="xl:w-1200 mx-6 xl:mx-auto">
      <a href="https://www.floodplain.com/"><img src="../assets/floodplain_logo.png" alt="Floodplain Consultants Incorporated" style=""></a>
    </div>

    <div class="xl:w-1200 mx-6 xl:mx-auto">
      <div class="topnav font-bold hidden sm:flex" v-if="currentRouteName != 'User Login'">
        <router-link class="topnav-component" v-for="item in navigation" :key="item.name" :to="item.to" @click="checkIfSameRoute(item.to.name, item.name)">
          {{ item.name }}
        </router-link>
        <div class="topnav-component cursor-pointer" @click="logout">
          Logout
        </div>
      </div>

      <div @click="open = !open" class="topnav sm:hidden cursor-pointer" :class="{'p-2': !open}" v-if="currentRouteName != 'User Login'">
          <div :class="{'m-2': open}">
            <span class="text-sm text-white">{{ currentName }}</span>
            <MenuIcon class="h-4 w-4 float-right text-white flex"></MenuIcon>
          </div>
          <router-link v-show="open" class="topnav-mobile-component flex text-white" v-for="item in navigation" :key="item.name" :to="item.to" @click="checkIfSameRoute(item.to.name, item.name)">
            {{ item.name }}
          </router-link>
          <div v-show="open" class="topnav-mobile-component cursor-pointer flex text-white" @click="logout">
            Logout
          </div>
      </div>

      <div class="border-2 my-4 bg-white rounded">
        <main class="flex-1 relative overflow-y-auto focus:outline-none">
          <div class="py-6 h-full">
            <div class="px-4 sm:px-6 h-full">
              <div class="py-4 h-full">
                  <slot></slot>
              </div>
            </div>
          </div>
        </main>

        <div v-if="currentRouteName != 'User Login'" class="grid col-940">
          <div class="grid col-540"></div><!-- end of col-540 -->
          <div class="grid col-380 fit">
            <ul class="social-icons"></ul><!-- .social-icons -->			
          </div><!-- end of col-380 fit -->
          <div class=" text-xs text-gray-600 text-center mx-4 mb-4">
            <div>
              Send Additional Information and/or Request Changes to:
            </div>
            <div>
              Fax No.(317) 858-­4421, Phone No. <a class="" style="color:blue" href="tel:800-945-0246">(800) 945­-0246</a>, <a style="color: blue" href="mailto:floodplain@floodplain.com">floodplain@floodplain.com</a>
            </div>
            <div>
              Please Provide FCI# When Contacting Us. Thank You!</div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
</body>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router';
import sharedAPI from '@/api/SharedAPI.js'
//import {router} from '@/router/index.ts'

const userNavigation = [
  { name: 'My Profile', href: 'localhost:8080/MyProfile.vue' },
  { name: 'Sign out', href: '#' },
]

export default defineComponent({
  name: 'ApplicationShellVerticalExample',
  components: {
    
  },
  setup() {
    const store = useStore()
    const route = useRouter()
    const sidebarOpen = ref(false)
    const currentPage = store.state.currentPage
    const currentPageParams = store.state.currentPageParams

    const open = ref(false)

    //Load file path of all modules named Nav.vue
    const context = require.context('@/modules', true, /Nav.ts$/i);

    const currentRouteName = computed(() =>{
      return route.currentRoute.value.name
    })

    async function logout() {
      store.commit('logout');
      await sharedAPI.logout()
      this.$router.push({ name: 'User Login'})
    } 

    const currentName = ref('New Request')
    //Reload page if route of navbar link is the same as current page
    function checkIfSameRoute(toName, fromName) {
      if (toName == currentRouteName.value){
        this.$router.go()
      }

      currentName.value = fromName
    }

    //Import each component
    const modules = context.keys()
        .map(context)
        .map(m => m.nav) 

    //Sort them based on the position data prop
    const navigation = modules.filter(m =>{
      return m.show
    }).sort((a,b)=>{
        let aPos = a.position
        let bPos = b.position
        if(aPos < bPos){
            return -1
        }else if(aPos > bPos){
            return 1
        }else{
            return 0
        }
    })

    return {
      navigation,
      userNavigation,
      sidebarOpen,
      store,
      currentPage,
      currentPageParams,
      currentRouteName,
      open,
      currentName,
      logout,
      checkIfSameRoute,
    }
  },
  methods: {
    goToProfile() {
      this.$router.push({name: "My Profile"})
    },    
  },
})
</script>

<style scoped>
  .topnav{
    background-color: #164B9C;
    background-image: linear-gradient(to bottom right, #164B9C 0%, #054776 100%);
    overflow: hidden;
  }

  .topnav-component{
    float: left;
    color: #fff;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    font-size: 17px;
    text-shadow: 0 -1px 0 #000;
    border-style: solid;
    border-left-width: 1px;
    border-right-width: 0px;
    border-color: #72759e;
  }

  .topnav-component:hover {
    background-image: linear-gradient(to bottom, #838383 0%, #414141 100%);
    color: white;
  }

  .topnav-component.active {
    background-color: #04AA6D;
    color: white;
  }

  .topnav-mobile-component{
    text-align: center;
    padding: 14px 10px;
    text-decoration: none;
    font-size: 14px;
    text-shadow: 0 -1px 0 #000;
    border-bottom: 1px;
    border-style: solid;
    border-color: #72759e;
  }

  body.background, html {
    min-height: 100vh;
  }
</style>